/**
 * League table order: total points first, like the website and the app. The sort is stable, so teams on equal
 * points keep the backend's order, which applies the format's ranking criteria (Total Points or Direct Matches).
 */
export function byTotalPoints<T extends { points: number }>(rows: T[]): T[];
export function byTotalPoints<T extends { points: number }>(rows: T[] | null | undefined): T[] | null | undefined;
export function byTotalPoints<T extends { points: number }>(rows: T[] | null | undefined) {
  return rows ? [...rows].sort((a, b) => b.points - a.points) : rows;
}
